import { motion } from 'framer-motion'
import AuthGradient from './AuthGradient'
import HanDuLogo from './HanDuLogo'
import { fadeUp, stagger, viewportOnce } from '../../motion'
import { legal } from '../data'

// Page chrome shared by /handu and /handu/privacy: the animated backdrop, a
// slim header, and the footer carrying the same copyright line the app shows
// in LegalFooter.swift.
export default function HanDuShell({ children }) {
  return (
    <>
      <AuthGradient />
      <div className="relative z-10 flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </>
  )
}

function Header() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="sticky top-0 z-50 border-b border-handu-outline/40 bg-handu-bg/70 backdrop-blur-md"
    >
      <nav className="mx-auto flex max-w-content items-center justify-between gap-4 px-5 py-3 sm:px-8">
        <a href="/handu" className="flex items-center gap-2.5">
          <HanDuLogo size={30} />
          <span className="text-base font-bold tracking-tight">HanDu</span>
        </a>
        <ul className="flex items-center gap-5 text-sm">
          <li>
            <a
              href="/handu/privacy"
              className="text-handu-soft transition-colors hover:text-handu-primary"
            >
              Privacy
            </a>
          </li>
          <li>
            <a
              href="/"
              className="text-handu-soft transition-colors hover:text-handu-primary"
            >
              yusufbrigui.com
            </a>
          </li>
        </ul>
      </nav>
    </motion.header>
  )
}

function Footer() {
  return (
    <footer className="mt-8 border-t border-handu-outline/40">
      <div className="mx-auto flex max-w-content flex-col items-center gap-2 px-5 py-10 text-sm text-handu-soft sm:px-8">
        <p>{legal.copyright}</p>
        <div className="flex items-center gap-4">
          <a
            href="/handu/privacy"
            className="text-handu-primary transition-opacity hover:opacity-70"
          >
            Privacy Policy
          </a>
          <span aria-hidden="true" className="text-handu-outline">
            ·
          </span>
          <a href="/" className="transition-colors hover:text-handu-primary">
            Back to portfolio
          </a>
        </div>
      </div>
    </footer>
  )
}

// The HanDu counterpart to src/components/Section.jsx. Same stagger/fadeUp
// scroll-in, but Section hardcodes the portfolio's mono eyebrow and
// font-black heading, which belong to the other design language.
export function HanDuSection({ id, eyebrow, title, children, className = '' }) {
  return (
    <section
      id={id}
      className={`mx-auto max-w-content px-5 py-14 sm:px-8 sm:py-20 ${className}`}
    >
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
      >
        {eyebrow && (
          <motion.p variants={fadeUp} className="handu-eyebrow mb-3">
            {eyebrow}
          </motion.p>
        )}
        {title && (
          <motion.h2
            variants={fadeUp}
            className="mb-8 text-3xl font-bold tracking-tight sm:mb-12 sm:text-4xl"
          >
            {title}
          </motion.h2>
        )}
        {children}
      </motion.div>
    </section>
  )
}
